import React, { useEffect, useState } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";

const Auth = () => {
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const send2FARequest = () => {
    const sessionId = localStorage.getItem("sessionId");
    const token = localStorage.getItem("token");

    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      return;
    }
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    axios
      .post(`/Account/EnableDisable2FA`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setToastMessage(response.data.message || "2FA Updated Successfully");
        setShowToast(true);
        setIs2FAEnabled((prev) => !prev);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      });
  };
  return (
    <>
      <div className="setting-header">
        <h4>2FA Authentication</h4>
      </div>
      <div className="p-3 privacy">
        <div className="d-flex align-items-center justify-content-between">
          <p className="sessionName">Enable Two-Factor Authentication</p>
          <div className="form-check form-switch">
            <input
              className="form-check-input custom-toggle"
              type="checkbox"
               role="switch"
              id="flexSwitchCheckChecked"
              checked={!is2FAEnabled}
              onChange={send2FARequest}
              disabled={loading}
            />
          </div>
        </div>

        {showToast && <div className="toast success">{toastMessage}</div>}
        {showErrorToast && (
          <div className="toast error">{ErrorToastMessage}</div>
        )}
      </div>

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default Auth;
